import {SessionService} from './SessionService';
import {environment} from './../../environments/environment';
import {UserNode} from './../model/user-node';
import {Site} from './../model/site';
import {DataService} from './data.service';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {Team} from '../model/team';
import {_} from 'underscore';
import { UserService } from './UserService';
import { UUID } from 'angular2-uuid';
import {Observable} from "rxjs/Observable";

@Injectable()
export class HierarchyService extends DataService {

  constructor(http: Http, session: SessionService, private userSevice: UserService) {
    super(environment.api.myshiftUrl + '/teams', http, session);
  }
  userNode: any;

  loadHierarchy() {
    return super.getAll(this.userSevice.getCurrentUser('userName'));
  }

  getAllSiteMembers(site: Site): UserNode[] {
    const members = [];
    site.teams.forEach(team => {
      team.users.forEach(user => {
        members.push(user);
      });
    });
    site.sitelinkedusers.forEach(sitelinkeduser => {
      members.push(sitelinkeduser);
    });
    return members;
  }

  getAllTeamMembers(team: Team): UserNode[] {
    const members = [];
    team.users.forEach(user => {
      members.push(user);
    });
    return members;
  }

  getAllMembersFromNode(sites: Site[], nodeId: number): UserNode[] {
    for (const site of sites) {
      /*if (site.id === nodeId) {
        return this.getAllSiteMembers(site);
      }*/
      for (const team of site.teams) {
        if (team.id === nodeId) {
          return this.getAllTeamMembers(team);
        }
        for (const user of team.users) {
          if (user.id === nodeId) {
            return [user];
          }
        }
      }
      for (const sitelinkeduser of site.sitelinkedusers) {
        if (sitelinkeduser.id === nodeId) {
          return [sitelinkeduser];
        }
      }
    }
    return [];
  }

getUnifiedNodes(sites: Array<any>){
    return sites.map(site => {
      // site.id = UUID.UUID();
      site.teams = site.teams.map(team => {
        team.id = UUID.UUID();
        team.users = team.users.map(user => {
          user.id = UUID.UUID();
          return {...user};
        })
        return {...team};
      })
      return {...site};
    });
  }

  buildTree(sites: any, query?: string, userNameVerrou?): Array<any> {
    sites = [...this.getUnifiedNodes(sites)]
    let nodes = [];
    if (userNameVerrou) {
      this.userNode = sites && sites.flatMap(s => s.teams).flatMap(t => t.users).find(user => user.username == userNameVerrou);
      nodes.push({
        id: this.userNode.id,
        name: this.buildUserNameNode(this.userNode),
        parent: this.userNode.parent,
        icon: 'person',
        siteName: null,
        teamName: null,
        agentName: this.buildUserNameNode(this.userNode),
        users: [this.userNode],
        periods: [{start: null, end: null}],
        villeLabel: sites[0].villeLabel
      });
    } else {
      _.each(sites, (s, i) => {
        nodes.push({
          id: s.id,
          name: s.nom,
          icon: 'keyboard_arrow_right',
          siteName: s.nom,
          teamName: null,
          agentName: null,
          class: 'sites_list'
        });
        _.each(s.teams, (t, e) => {
          nodes.push({
            id: t.id,
            name: t.libelle,
            parent: s.id,
            icon: 'supervisor_account',
            siteName: s.nom,
            teamName: t.libelle,
            isPrincipal: t.isPrincipal,
            teamAssignment: t.teamAssignment,
            agentName: null,
            users: t.users,
            class: 'teams_list'
          });
          _.each(t.users.filter(user => user.username != this.userSevice.getCurrentUser('userName')), (u, o) => {
            nodes.push({
              id: u.id,
              name: this.buildUserNameNode(u),
              parent: t.id,
              icon: 'person',
              siteName: s.nom,
              teamName: t.libelle,
              agentName: this.buildUserNameNode(u),
              users: [u],
              periods: t.tlPeriods,
              villeLabel: s.villeCode,
              class: 'persons_list'
            });
          });
        });
        _.each(s.sitelinkedusers, (slu, e) => {
          nodes.push({
            id: slu.id,
            name: this.buildUserNameNode(slu),
            parent: s.id,
            icon: 'person',
            siteName: s.nom,
            teamName: null,
            agentName: this.buildUserNameNode(slu), users: [slu],
            periods: [{start: null, end: null}],
            villeLabel: s.villeLabel
          });
        });
      });
    }
    return nodes;
  }

  buildUserNameNode(user: UserNode) {
    return user.firstName + ' ' + user.lastName + ' [' + user.username + ']';
  }

  getQualityTreeUsers() {
    return this.http.get(`${environment.api.myshiftUrl}/teams/support`, { headers: this.session.getHeaders() }).map(response => response.json());
  }

  isUserFiltered(user: UserNode, query: string): boolean {
    query = query.toLowerCase();
    const name = user.firstName.toLowerCase() + ' ' + user.lastName.toLowerCase();
    return user.firstName.toLowerCase().includes(query) ||
        user.lastName.toLowerCase().includes(query) ||
        user.username.toString().toLowerCase().includes(query) ||
        name.includes(query);
  }

}



// WEBPACK FOOTER //
// ./src/app/service/hierarchy.service.ts